export function generateUniqueID(identifier?: string): string {
  const randomString = Math.random().toString(36).substring(2, 8);
  const timestamp = new Date().getTime();
  if (!identifier) {
    return randomString + timestamp;
  }
  return `${identifier}-${randomString}${timestamp}`;
}

